var array = Array.prototype;

export var slice = array.slice;
export var map = array.map;



//////////////////
// WEBPACK FOOTER
// ./~/d3/~/d3-array/src/array.js
// module id = 101
// module chunks = 0 1 2 3 4